<script setup>
import TitleComponent from '@/components/TitleComponent/index.vue'
import tabsView from '@/components/tabsView/index.vue'
import router from '@/router'
import { getUserOrder, cancelOrderAPI, statusOrderAPI, setUpdataShippingNumberAPI, getCnLogisticsListApi } from '@/apis/order'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { formatToLocalTime, exchangeOrderRate, symbolStatus, payState, fomartPayState, exchangeOrderTotalRate } from '@/utils/index'
import { useUserStore } from '@/stores/userStore'
const userStore = useUserStore()
const ipTime = userStore.ipTime;
const { t } = useI18n();

// tab列表
const tabTypes = [
    { id: 1, name: t('number70') },
    { id: 2, name: t('number71') },
    { id: 3, name: t('number72') },
    { id: 6, name: t('number60') },
    { id: 4, name: t('number73') },
    { id: 5, name: t('number74') },
]
// 总数量
const total = ref(0)
// 获取订单列表
const orderList = ref([])
const params = reactive({
    fromData: {
        filter_status: '0',
        sell_type: 2,
        page: 1,
        page_size: 5
    }

})

const getOrderList = async () => {
    console.log('查询条件', params.fromData);
    const res = await getUserOrder(params.fromData)
    if (res.data.list) {
        let data = res.data.list


        data.forEach((group) => {
            group?.order_list?.forEach((list)=>{
                // 使用 reduce 计算每个 group 的 items 中的 value 合计
                list.totalValue = list.products.reduce((sum, item) =>
                    sum + parseFloat(exchangeOrderTotalRate(item.price, item.buy_num, userStore.exchangeRate.symbol, userStore.exchangeRate.currency, userStore.exchangeRate.rate)), 0);
                })
            });
        console.log('数据值', data)
        orderList.value = data
        // orderList.value = res.data.list
        if (res.data.list.length == 0) {
            if (params.fromData.page > 1) {
                params.fromData.page = params.fromData.page - 1

                pageChange(params.fromData.page)
            }
        }
        total.value = res.data.page.total
    }
}

const loading = ref(false)
const noMore = computed(() => {
    if (orderList.value) {
        if (orderList.value.length >= total.value) {
            return true;
        } else {
            return false;
        }
    }
})
const disabled = computed(() => loading.value || noMore.value)
const load = () => {

    loading.value = true
    setTimeout(async () => {
        params.fromData.page++
        const res = await getUserOrder(params.fromData)
        if (res.data.list) {
            let data = res.data.list


            data.forEach((group) => {
                // 使用 reduce 计算每个 group 的 items 中的 value 合计
                group.totalValue = group.products.reduce((sum, item) =>
                    sum + parseFloat(exchangeOrderTotalRate(item.price, item.buy_num, userStore.exchangeRate.symbol, userStore.exchangeRate.currency, userStore.exchangeRate.rate)), 0);
            });
            console.log('数据值', data)
            // orderList.value = data
            orderList.value = [...orderList.value, ...data]
            loading.value = false
        }

    }, 100)
}
const isMobile = ref(false);//false代表pc
onMounted(() => {
    getOrderList()
    getCnLogistics()
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    console.log('Is mobile device:', isMobile.value);
})

// tab切换
const tabChange = (type) => {
    console.log(type);
    if (type == 1) {
        params.fromData.filter_status = 0
        params.fromData.page = 1
    } else if (type == 2) {
        params.fromData.filter_status = 1
        params.fromData.page = 1
    } else if (type == 3) {
        params.fromData.filter_status = 2
        params.fromData.page = 1
    } else if (type == 4) {
        params.fromData.filter_status = 3
        params.fromData.page = 1
    } else if (type == 5) {
        params.fromData.filter_status = 4
        params.fromData.page = 1
    } else if (type == 6) {
        params.fromData.filter_status = 5
        params.fromData.page = 1
    }
    getOrderList();
}


// 页数切换
const pageChange = (page) => {
    console.log(page);
    params.fromData.page = page
    getOrderList()
}


// const fomartPayState = (payState) => {
//     const stateMap = {
//         1: t('setup56'),
//         // 2: '部分发货',
//         3: t('number76'),
//         4: t('number73'),
//         5: t('number74'),
//         0: t('number31'),
//         6: t('number71')
//     }
//     return stateMap[payState]
// }
const activeNames = ref([])
const handleChange = (val) => {
    console.log(val)
}
const dialogVisible = ref(false)
const updatlogistics = ref(0)
const orderitem = ref(false)
const needIntlPostage = ref(false)
const statusOrder = async (id, status, isneedIntlPostage,number) => {
    if (status == 1) {
        updatlogistics.value = 1
        //修改物流单号
        param.from.shippingNumber = number
    } else {
        updatlogistics.value = 0
        param.submitFrom.status = 40

    }
    if (isneedIntlPostage) {
        //不包邮商品
        needIntlPostage.value = true
    } else {
        needIntlPostage.value = false
    }
    dialogVisible.value = true
    param.submitFrom.order_no = id

}
const handleClose = () => {
    dialogVisible.value = false
    param.from.shippingNumber = ''
    param.needIntlPostagefrom.logistics_code = ''
    param.needIntlPostagefrom.logistics_custom_data = ''
    // console.log()
    params.fromData.page = 1
    getOrderList()
}

const logisticsList = ref([]);
const getCnLogistics = () => {
    getCnLogisticsListApi({}).then((data) => {
        logisticsList.value = data?.data?.list
        console.log('data.listdata.list', data?.data?.list)
    })
}
const formRef = ref(null)
const param = reactive({
    submitFrom: {
        order_no: null,
        shipping_number: null,
        status: null,
        order_type: 1,
    },
    from: {
        shippingNumber: null
    },
    needIntlPostagefrom: {
        logistics_code: null,
        logistics_custom_data: null,
    }
})
const rules = {
    shippingNumber: [
        { required: true, message: t('number77'), trigger: 'blur' }
    ],
    logistics_custom_data: [
        { required: true, message: t('setup676'), trigger: 'blur' }
    ],
}
/**
 * 发货
 */
const submit = async () => {
    if (updatlogistics.value == 1) {//修改物流单号
        let data = {
            order_no: param.submitFrom.order_no,
            shipping_number: param.from.shippingNumber
        }
        const res = await setUpdataShippingNumberAPI(data)
        if (res.code == 0) {
            ElMessage({ type: 'success', message: t('number78') })
            handleClose()
        } else {
            ElMessage({ type: 'error', message: res.message })
        }
    } else {//发货
        param.submitFrom.shipping_number = param.from.shippingNumber
        let data = param.submitFrom
        if (needIntlPostage) {
            data.logistics_code = param.needIntlPostagefrom.logistics_code
            data.logistics_custom_data = param.needIntlPostagefrom.logistics_custom_data
        }
        const res = await statusOrderAPI(data)
        if (res.code == 0) {
            ElMessage({ type: 'success', message: t('number78') })
            handleClose()
        } else {
            ElMessage({ type: 'error', message: res.message })
        }
    }

}
const orderid = ref()
const orderView = ref(false)
const oredrModel = (id) => {
    orderid.value = id
    orderView.value = true
}
const close = () => {
    orderView.value = false
}
const goOrderDetails = (no) => {
    router.push('/orderDetails/' + no + '/1')
}
/**
 * 查看商品详情
 */
const goTheWolfDetails = (id) => {
    router.push('/detail/' + id)
}
</script>

<template>
    <TitleComponent :title="t('number79')" v-if="isMobile"></TitleComponent>
    <div class="order">
        <div class="buy-title" v-if="isMobile == false">
            {{ $t('number79') }}
        </div>
        <tabsView :tabsList="tabTypes" @setCheckTabs="tabChange" :bottom="'true'" class="tabsView" v-if="isMobile">
        </tabsView>
        <tabsView :tabsList="tabTypes" @setCheckTabs="tabChange" :bottom="'false'" class="tabsView" v-else></tabsView>

        <div class="order-container">

            <div class="main-container">
                <div class="holder-container" v-if="orderList.length === 0">
                    <el-empty :description="t('number80')" />
                </div>
                <div v-else>
                    <div class="pc" v-if="isMobile == false">
                        <div v-for="(list,key) in orderList" :key="key" style="margin-bottom: 10px;">
                            <div class="tophead">{{ $t('number81') }}：{{ list.order_view_no }}</div>
                            <div class="head ">
                                <!-- <span>{{$t('number81')}}：{{ order.order_no }}</span> -->

                                <!-- 未付款，倒计时时间还有 -->
                                <span>{{ $t('number83') }}：{{ list.shop_user }}</span>
                                <span>{{ $t('number82') }}：{{ formatToLocalTime(ipTime, list.created_at * 1000) }}</span>
                                <!-- <span class="down-time ">
                                    <i class="iconfont icon-down-time"></i>
                                    <b>{{$t('number84')}}: {{ formatToLocalTime(ipTime,order.updated_at) }}</b>
                                </span> -->
                            </div>
                            <div  v-for="(order,keys) in  list.order_list" :key="keys">
                                <div class="head" v-if="list.order_list?.length>1" style=" background-color: #fff;
    color: #000;
    border: 1px solid rgb(229, 232, 236);
    border-bottom: none;border-top: none;">
                                    <div>{{ $t('number81') }}: {{ order.order_no }}</div>
                                </div>
                                <div style="display: flex;justify-content: space-between;">
                                    <div style="height: auto;display: flex;flex-direction: column; border: 1px solid #E5E8EC;border-top: none;">
                                        <!-- 订单列表 -->
                                        <div class="order-item" v-for="item in order.products" :key="item.id">

                                            <div class="body">
                                                <div class="column goods">
                                                    <ul>
                                                        <li>
                                                            <div class="Product" @click="goTheWolfDetails(item.product_id)">
                                                                <a class="Productimage" href="javascript:;">
                                                                    <img :src="item.cover_url" alt="" />
                                                                </a>
                                                                <div class="info">
                                                                    <p class="name ellipsis">
                                                                        {{ item.product_name }}
                                                                    </p>
                                                                    <p class="skuname">
                                                                        {{ item.sku_name }}
                                                                    </p>
                                                                    <p class="skuname" style="color: red;" v-if="item.needIntlPostage">
                                                                        {{ $t('setup670') }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="seesaw">
                                                                <div class="price">
                                                                    <span class="red"
                                                                        v-if="order.currency == ''">{{ exchangeOrderRate(item.price, userStore.exchangeRate.symbol,
                                                                        userStore.exchangeRate.currency,
                                                                        userStore.exchangeRate.rate) }}</span>
                                                                    <span class="red" v-else> {{
                                                                        symbolStatus(order.currency) }}{{ item.price
                                                                        }}</span>
                                                                </div>
                                                                <div class="count"> * {{ item.buy_num }}</div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="borderDIV">
                                        <div style="padding-top: 10px;">
                                            <p>{{ payState(order.pay_type) }}</p>
                                            <p style="padding: 5px 0;">
                                                <a :href="`${order.telegram}`" target="_blank" rel="nofollow"
                                                    v-if="order.telegram" class="button" style="padding: 0 4px;">
                                                    <img src="../../../assets/images/telegram.png"
                                                        style="width: 20px;height: 20px;" alt="" srcset="">
                                                </a>

                                                <a v-if="order.watch_app" :href="`${order.watch_app}`" target="_blank"
                                                    rel="nofollow" class="button">
                                                    <img src="../../../assets/images/watch.png"
                                                        style="width: 20px;height: 20px;border-radius: 50%;    " alt=""
                                                        srcset="">
                                                </a>
                                            </p>
                                        </div>
                                        <p @click="goOrderDetails(order.order_no)">
                                            <a href="javascript:;" class="green">{{ $t('number85') }}</a>
                                        </p>
                                    </div>
                                    <div class="borderDIV">
                                        <p>
                                            {{ fomartPayState(order.status) }}
                                        </p>
                                    </div>
                                    <div class="borderDIV sum">
                                        {{ $t('number86') }}
                                        <span v-if="order.currency == ''">{{ userStore.exchangeRate.symbol }}{{ order.totalValue
                                            }}</span>
                                        <span v-else> {{ symbolStatus(order.currency) }}{{ order.total_price }}</span>
                                    </div>
                                    <div class="borderDIV butdiv">

                                        <el-button class="but" v-if="order.status == 20" type="primary" size="small"
                                            @click="statusOrder(order.order_no, 3, order.needIntlPostage)" plain>
                                            {{ $t('number32') }}
                                            <!-- 待发货-->
                                        </el-button>
                                        <el-button class="but" v-if="(order.status == 40||order.status == 41 )&& order.extends.sn_modify_count < 1"
                                            type="primary" size="small"
                                            @click="statusOrder(order.order_no, 1, order.needIntlPostage, order.shipping_number)" plain>
                                            {{ $t('setup587') }}
                                            <!-- 修改物流单号-->
                                        </el-button>


                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="pagination-container">
                            <el-pagination :total="total" @current-change="pageChange"
                                :current-page="params.fromData.page" :page-size="params.fromData.page_size" background
                                layout="prev, pager, next" />
                        </div>
                    </div>
                    <div class="infinite-list-wrapper" v-else>
                        <ul v-infinite-scroll="load" class="list" :infinite-scroll-disabled="disabled">
                            <div v-for="(list,index) in orderList" :key="index"  class="listItem">

                               <div class="tophead">
                                    <div style="font-size: 13px;">{{ list.shop_user }}</div>
                                </div> 
                                <div v-for="(order,keys) in  list.order_list" :key="keys">
                                <div class="headNO" style="border-top: 1px solid #EEEEEE;">
                                    <div style="font-size: 13px;">{{ order.order_no }}</div>
                                </div>
                                <div class="order-item">

                                    <div class="body">
                                        <div class="column goods" v-for="item in order.products" :key="item.id">
                                            <ul>
                                                <li @click="goTheWolfDetails(item.product_id)">
                                                    <a class="image" href="javascript:;">
                                                        <img :src="item.cover_url" alt="" />
                                                    </a>
                                                    <div class="info">
                                                        <p class="name ellipsis-2">
                                                            {{ item.product_name }}
                                                        </p>
                                                        <p class="norm">
                                                            {{ item.sku_name }} *{{ item.buy_num }}
                                                        </p>
                                                        <div class="seesaw">
                                                            <div class="price">
                                                                <span class="red"
                                                                    v-if="order.currency == ''">{{ exchangeOrderRate(item.price, userStore.exchangeRate.symbol,
                                                                    userStore.exchangeRate.currency,
                                                                    userStore.exchangeRate.rate) }}</span>
                                                                <span class="red" v-else> {{
                                                                    symbolStatus(order.currency) }}{{ item.price
                                                                    }}</span>

                                                            </div>
                                                        </div>
                                                    </div>


                                                </li>
                                            </ul>
                                        </div>
                                        <div class="StatusTotal flexEnd">
                                            <div class="status">{{ fomartPayState(order.status) }}&nbsp;&nbsp;</div>
                                            <div class="Total ">{{ $t('number86') }}：
                                                <span class="red"
                                                    v-if="order.currency == ''">{{ userStore.exchangeRate.symbol }}{{
                                                    order.totalValue}}</span>
                                                <span class="red" v-else> {{ symbolStatus(order.currency) }}{{
                                                    order.total_price }}</span>
                                            </div>
                                        </div>
                                        <!-- <div style="text-align: end;padding-right: 10px;">
                                            {{ fomartPayState(order.status) }}

                                        </div> -->
                                        <div class="DetailsBUT aboutflex">
                                            <div>
                                                <p @click="goOrderDetails(order.order_no)">
                                                    <a href="javascript:;" class="green">{{ $t('number88') }}</a>
                                                </p>
                                            </div>
                                            <div class="subBUT">
                                                <div class="but HorizontalCenter" v-if="order.status == 20"
                                                    type="primary" size="small"
                                                    @click="statusOrder(order.order_no, 3, order.needIntlPostage)"
                                                    plain>
                                                    {{ $t('number32') }}
                                                    <!-- 待发货 -->
                                                </div>
                                                <div class="but HorizontalCenter"
                                                    v-if="(order.status == 40||order.status == 41 ) && order.extends.sn_modify_count < 1"
                                                    type="primary" size="small"
                                                    @click="statusOrder(order.order_no, 1, order.needIntlPostage, order.shipping_number)"
                                                    plain>
                                                    {{ $t('setup587') }}
                                                    <!-- 修改物流单号 -->
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="column">
                                            <div style="display: flex;justify-content: space-between;padding: 0 10px;">
                                                <div>
                                                    <p @click="goOrderDetails(order.order_no)">
                                                        <a href="javascript:;" class="green">{{ $t('number88') }}</a>
                                                    </p>
                                                </div>
                                                <div class="red">{{$t('number86')}} ：{{symbolStatus(order.currency)}}{{ order.pay_amount }}</div>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                                <!-- <div class="column action" style="margin-top: 8px;text-align: end;margin-bottom: 19px;">
                                  
                                    <el-button class="but" v-if="order.status == 1" type="primary" size="small"
                                        @click="statusOrder(order.order_no, 3)" plain>
                                       {{ $t('number87') }}
                                    </el-button>
                                </div> -->
                            </div>
                        </ul>
                        <p v-if="loading" style="text-align: center;">Loading...</p>
                        <p v-if="noMore" style="text-align: center;">No more</p>
                    </div>


                </div>
            </div>
            <el-dialog v-if="isMobile == false" v-model="dialogVisible" :title="t('number89')" width="350"
                :before-close="handleClose">
                <el-form ref="formRef" :model="param.from" size="large" :rules="rules" label-position="top"
                    label-width="60px">
                    <el-form-item prop="shippingNumber" :label="t('number90')" class="form-item">
                        <el-input v-model="param.from.shippingNumber" :placeholder="t('number91')">
                        </el-input>
                    </el-form-item>
                    <el-form-item v-if="needIntlPostage" prop="shippingNumber" :label="t('setup671')" class="form-item">
                        <el-select v-model="param.needIntlPostagefrom.logistics_code" :placeholder="t('setup672')" filterable>
                            <el-option v-for="item in logisticsList" :key="item.code" :label="item.name"
                                :value="item.code" />
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        v-if="needIntlPostage && (param.needIntlPostagefrom.logistics_code == 'SF' || param.needIntlPostagefrom.logistics_code == 'KYSY')"
                        :label="t('setup673')" prop="logistics_custom_data" class="form-item">
                        <el-input v-model="param.needIntlPostagefrom.logistics_custom_data" :placeholder="t('setup674')" />
                    </el-form-item>

                    <el-form-item v-if="needIntlPostage && param.needIntlPostagefrom.logistics_code == 'CNCY'"
                        :label="t('setup671')" prop="logistics_custom_data" class="form-item">
                        <el-input v-model="param.needIntlPostagefrom.logistics_custom_data" />
                    </el-form-item>


                </el-form>
                <template #footer>
                    <div class="dialog-footer">
                        <el-button @click="handleClose">Cancel</el-button>
                        <el-button type="primary" @click="submit">
                            submit
                        </el-button>
                    </div>
                </template>
            </el-dialog>
            <el-drawer v-if="isMobile == true" v-model="dialogVisible" :title="t('number89')" class="phone" show-close
                :with-header="true" direction="btt" :before-close="handleClose" size="50%">

                <el-form ref="formRef" :model="param.from" size="large" :rules="rules" label-position="top"
                    label-width="60px">
                    <el-form-item prop="shippingNumber" :label="t('number90')" class="form-item">
                        <el-input v-model="param.from.shippingNumber" :placeholder="t('number91')">
                        </el-input>
                    </el-form-item>
                    <el-form-item v-if="needIntlPostage" prop="shippingNumber" :label="'物流公司'" class="form-item">
                        <el-select v-model="param.needIntlPostagefrom.logistics_code" placeholder="选择物流公司" filterable>
                            <el-option v-for="item in logisticsList" :key="item.code" :label="item.name"
                                :value="item.code" />
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        v-if="needIntlPostage && (param.needIntlPostagefrom.logistics_code == 'SF' || param.needIntlPostagefrom.logistics_code == 'KYSY')"
                        :label="'寄件人尾号'" prop="logistics_custom_data" class="form-item">
                        <el-input v-model="param.needIntlPostagefrom.logistics_custom_data" placeholder="后四位" />
                    </el-form-item>

                    <el-form-item v-if="needIntlPostage && param.needIntlPostagefrom.logistics_code == 'CNCY'"
                        :label="'货主编号'" prop="logistics_custom_data" class="form-item">
                        <el-input v-model="param.needIntlPostagefrom.logistics_custom_data" />
                    </el-form-item>
                </el-form>
                <template #footer>
                    <div class="dialog-footer">
                        <el-button @click="handleClose">Cancel</el-button>
                        <el-button type="primary" @click="submit">
                            submit
                        </el-button>
                    </div>
                </template>
            </el-drawer>
        </div>
    </div>
</template>

<style scoped lang="scss">
.phone {
    display: none;
}

.pc {
    display: block;
}

.buy-title {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 18px;
    color: #11192D;
    line-height: 18px;
    text-align: left;
    font-style: normal;
    padding: 30px 20px;
}

.order-container {
    background: #ffffff;
    padding: 0px 20px 20px 20px;
    border-radius: 8px;

    user-select: text;

    .pagination-container {
        display: flex;
        justify-content: center;
    }

    .main-container {
        min-height: 500px;

        .holder-container {
            min-height: 500px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}

.tophead {
    padding: 10px 24px;
    background: #F3F6F8;
    border-radius: 8px 8px 0px 0px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #666666;
    line-height: 19px;
    text-align: left;
    font-style: normal;
}

.head {
    // height: 50px;
    padding: 18px 24px;
    line-height: 50px;
    // background: #f5f5f5;
    background: #FF9845;
    // padding: 0 20px;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 19px;
    text-align: left;
    font-style: normal;

    span {
        margin-right: 20px;

        &.down-time {
            margin-right: 0;
            float: right;

            i {
                vertical-align: middle;
                margin-right: 3px;
            }

            b {
                vertical-align: middle;
                font-weight: normal;
            }
        }
    }

    .del {
        margin-right: 0;
        float: right;
        color: #999;
    }
}

.butdiv {
    padding: 16px 11px;
    text-align: end;

    .but {
        margin: 5px 0px;
    }
}

.sum {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #666666;
    line-height: 22px;
    text-align: right;
    font-style: normal;
    // text-align: end;
    // padding: 0;

    // border-bottom: 1px solid #ebeef5;

}


.borderDIV {
    width: 140px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-bottom: 1px solid #E5E8EC;
    border-right: 1px solid #E5E8EC;
    border-top: 1px solid #E5E8EC;
    align-items: center;

    .green {
        color: $xtxColor;
    }
}

.price {
    color: red;
}

.order {
    background: #ffffff;
    border-radius: 8px;
    height: 100%;
}

.order-item {
    // height: 100%;
    // margin-bottom: 20px;
    // border: 1px solid #E5E8EC;
    flex: 1;


    .body {
        height: 100%;
        display: flex;
        align-items: stretch;

        .column {
            border-left: 1px solid #E5E8EC;
            ;
            text-align: center;
            // padding: 20px;

            >p {
                padding-top: 10px;
            }

            &:first-child {
                border-left: none;
            }

            &.goods {
                height: 100%;
                flex: 1;
                padding: 0;
                align-self: center;

                ul {
                    height: 100%;

                    li {
                        // border-top: 1px solid #E5E8EC;
                        height: 100%;
                        // border-bottom: 1px solid #E5E8EC;;
                        display: flex;
                        align-items: center;

                        &:last-child {
                            // border-bottom: none;
                            border-top: 1px solid #E5E8EC;
                        }

                        .Product {
                            padding: 20px 0 20px 20px;
                            display: flex;

                            .Productimage {
                                width: 78px;
                                height: 78px;
                                background: #F5F6F8;
                                border-radius: 8px;
                                border: 1px solid #E5E8EC;
                                ;

                                img {
                                    border-radius: 8px;
                                    width: 78px;
                                    height: 78px;
                                }
                            }

                            .info {
                                width: 193px;
                                text-align: left;
                                padding: 0 10px;

                                p {
                                    // margin-bottom: 5px;

                                    &.name {
                                        height: 38px;
                                    }

                                    &.skuname {
                                        font-family: MicrosoftYaHei;
                                        font-size: 14px;
                                        color: #666666;
                                        line-height: 19px;
                                        text-align: left;
                                        font-style: normal;
                                    }

                                    &.attr {
                                        color: #999;
                                        font-size: 12px;

                                        span {
                                            margin-right: 5px;
                                        }
                                    }
                                }
                            }
                        }




                        .seesaw {
                            width: 74px;
                            padding: 30px 0 48px;
                            border-left: 1px solid #E5E8EC;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            font-family: MicrosoftYaHei;
                            font-size: 14px;
                            color: #666666;
                            line-height: 19px;
                            text-align: left;
                            font-style: normal;
                        }

                        // .price {
                        //     // width: 100px;
                        // }

                        // .count {
                        //     // width: 80px;
                        // }
                    }
                }
            }

            .red {
                color: $priceColor;
            }

            &.state {
                width: 120px;
                display: flex;
                flex-direction: column;
                justify-content: center;

                .green {
                    color: $xtxColor;
                }
            }

            &.amount {
                width: 200px;
                display: flex;
                flex-direction: column;
                justify-content: center;


            }

            &.action {
                width: 200px;
                display: flex;
                flex-direction: column;



                // a {
                //     display: block;

                //     &:hover {
                //         color: $xtxColor;
                //     }
                // }
            }
        }
    }
}

.address {
    padding: 0 20px;
}

:deep(.el-collapse-item__header) {
    padding: 0px 20px;
}



@media (max-width: 768px) {
    .order {
        background: #f7f7f7;
        height: 100%;
    }

    .phone {
        display: block;
    }

    .pc {
        display: none;
    }

    .green {
        color: $xtxColor;
    }

    .tabsView {
        margin-top: 45px;
        padding-top: 15px;
    }

    .order-container {
        background: #f7f7f7;
        // margin-top: 36px;
        // padding: 10px 10px 66px 10px;


    }

    .More {
        padding: 5px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        line-height: 14px;
        text-align: left;
        font-style: normal;
    }

    .infinite-list-wrapper {
        .list {
            .listItem {
                margin-bottom: 15px;
            }

            .tophead {
                background: #FF9845;
                border-radius: 6px 6px 0px 0px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #FFFFFF;
                line-height: 12px;
                text-align: left;
                font-style: normal;
                padding: 10px 15px;
            }

            .headNO {
                padding: 11px 15px;
                background-color: #ffffff;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #333333;
                line-height: 12px;
                text-align: left;
                font-style: normal;
                border-bottom: 1px solid #EEEEEE;
                ;
            }

            .order-item {
                background-color: #ffffff;
                height: 100%;
                // box-shadow: 0px 4px 20px 6px rgba(237, 237, 237, 0.75);
                // border-radius: 4px;
                border-end-end-radius: 4px;
                border-end-start-radius: 4px;

                // border-bottom: 4px;
                .body {
                    flex-direction: column;

                    .goods {
                        // height: 96px;

                        ul li {
                            &:last-child {
                                // border-bottom: none;
                                border-top: 0px solid #E5E8EC;
                            }

                            .image {
                                img {
                                    width: 82px;
                                    height: 82px;
                                    border-radius: 8px;
                                    // width: 100%;
                                }
                            }

                            .info {
                                width: calc(100% - 92px);
                                padding-left: 10px;
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 400;
                                font-size: 14px;
                                color: #222222;
                                line-height: 20px;
                                text-align: left;
                                font-style: normal;

                                .norm {
                                    font-family: PingFangSC, PingFang SC;
                                    font-weight: 400;
                                    font-size: 12px;
                                    color: #888888;
                                    line-height: 17px;
                                    text-align: left;
                                    font-style: normal;
                                    padding-bottom: 11px;
                                }

                                .seesaw {
                                    width: 100%;
                                    // height: 100%;
                                    padding: 0;
                                    border-left: 0px solid #E5E8EC;
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: center;
                                    align-items: flex-start;
                                    font-family: MicrosoftYaHei;
                                    font-size: 14px;
                                    color: #666666;
                                    line-height: 19px;
                                    text-align: left;
                                    font-style: normal;
                                }
                            }
                        }


                    }

                    .StatusTotal {
                        border-top: 1px solid #EEEEEE;
                        padding: 15px;
                        border-bottom: 1px solid #EEEEEE;

                        .status {
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 12px;
                            color: #222222;
                            line-height: 12px;
                            text-align: left;
                            font-style: normal;
                        }

                        .Total {
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 12px;
                            color: #888888;
                            line-height: 14px;
                            text-align: left;
                            font-style: normal;

                            .red {
                                color: #FF4F00;
                            }
                        }
                    }

                    .DetailsBUT {
                        padding: 15px;

                        .detail {
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 12px;
                            color: #333333;
                            line-height: 14px;
                            text-align: left;
                            font-style: normal;
                        }

                        .subBUT {
                            .but {
                                height: 28px;
                                background: #F6F6F6;
                                border-radius: 14px;
                                padding: 0 19px;
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 400;
                                font-size: 12px;
                                color: #333333;
                                line-height: 14px;
                                text-align: left;
                                font-style: normal;
                                margin: 0 2px;
                            }
                        }

                    }


                }

                .column {
                    border-left: 1px solid transparent;
                    padding: 14px 15px;
                    width: 100%;

                    &.action {
                        width: 100%;


                    }

                    &.amount {
                        width: 100%;
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-end;
                        padding-right: 20px;

                    }

                    &.order {
                        color: #909399;
                        display: flex !important;
                        justify-content: center !important;
                        align-items: center !important;

                        .orderitem {
                            width: 100% !important;
                            font-size: 13px !important;
                            padding: 5px 5px !important;
                        }

                        .item {
                            width: 100% !important;

                            display: flex !important;
                            justify-content: space-between;
                        }
                    }

                    &.action {
                        width: 100% !important;
                        display: flex;
                        flex-direction: row !important;
                        justify-content: flex-end;
                        border-top: 1px solid #f5f5f5;

                        .but {
                            margin: 5px;
                        }
                    }
                }
            }
        }
    }

}
</style>